

<!-- 公司绝密★5年 -->

<template>
  <div id="app">
    <router-view v-wechat-title="$route.meta.title" v-if="isRouterAlive"></router-view>
  </div>
</template>

<script>
import { getProjectSetting } from "../src/utils/api";
export default {
  name: "App",
  provide() {
    return {
      reload: this.reload
    }
  },
  data() {
    return {
      rollNumColor: {},
      rollNumColorArr: [],
      icvColor: {},
      icvColorArr: [],
      isRouterAlive: true
    };
  },
  components: {},
  created() {
    this.rollNumColor = this.$store.state.rollNumColor;
    this.rollNumColorArr = this.$store.state.rollNumColorArr;
    this.icvColor = this.$store.state.icvColor;
    this.icvColorArr = this.$store.state.icvColorArr;
    let baseURL = ''
    let webSocketUrl = ''
    // if(process.env.NODE_ENV === 'development') {
    // 开发环境相关特殊方法
    // baseURL = 'https://ljszh.sany.com.cn'
    // webSocketUrl = 'ljszh.sany.com.cn'
    // baseURL = 'http://10.0.14.247:8017'
    //   webSocketUrl = '10.0.14.247:8017'
    // baseURL = 'http://10.8.218.47:31003' //黄华军
    // webSocketUrl = '10.8.218.47:31003'
    // baseURL = 'http://10.8.206.199:31003' //郭海良
    // webSocketUrl = '10.8.206.199:31003'
    // baseURL = 'http://10.8.220.143:31003' //张彪
    // webSocketUrl = '10.8.220.143:31003'
    // baseURL = 'http://10.25.121.53:31003' //钟芳
    // webSocketUrl = '10.25.121.53:36100'
    // }
    baseURL = 'https://ljszh.test.rootcloudapp.com'
    webSocketUrl = 'ljszh.test.rootcloudapp.com'
    if (window.location.href.indexOf('10.0.14.247') > 0) {
      // 测试环境相关特殊方法
      baseURL = 'http://10.0.14.247:8017'
      webSocketUrl = '10.0.14.247:8017'
    }
    if (window.location.href.indexOf('ljszh.sany.com.cn') > 0) {
      // 生产环境相关特殊方法
      baseURL = 'https://ljszh.sany.com.cn'
      webSocketUrl = 'ljszh.sany.com.cn'
      // baseURL = 'http://10.0.14.247:8017'
      // webSocketUrl = '10.0.14.247:8017'
    }
    if (window.location.href.indexOf('ljszh.test.rootcloudapp.com') > 0) {
      // 新路机测试环境
      baseURL = 'https://ljszh.test.rootcloudapp.com'
      webSocketUrl = 'ljszh.test.rootcloudapp.com'
    }
    window.localStorage.setItem("baseURL", baseURL);
    window.localStorage.setItem("webSocketUrl", webSocketUrl);
    // getEquipTypeList({ pageSize: 100 }).then((res) => {
    //   if(res.data.code==200){
    //     this.$store.commit("setEquipTypeList", res.data.content.list);
    //   }
    // })

    this.initRollParameter(localStorage.getItem('projectSetId'))
  },
  // mounted
  methods: {
    reload() {
      this.isRouterAlive = false
      this.$nextTick(function () {
        this.isRouterAlive = true
      })
    },
    /**
     * 初始化碾压遍数/压实度热力图参数
     */
    initRollParameter(projectId) {
      let that = this;

      if (projectId) {
        let params = {
          projectId: projectId,
        };

        getProjectSetting(params).then((res) => {
          let info = res.data.content.info;
          let compactionColorList = info.compactionColorList;
          let rollingColorList = info.rollingColorList;
          let paverTemperatureColorList = info.paverTemperatureColorList
          let temperatureColorList = info.temperatureColorList

          let rollNumColorArr = new Array();
          let rollNumColor = {};
          let icvColor = {};
          let icvColorArr = new Array();
          let pavColor = {};
          let pavColorArr = new Array();
          let rollColor = {};
          let rollColorArr = new Array();

          if (
            rollingColorList != null &&
            rollingColorList != undefined &&
            rollingColorList.length > 0
          ) {
            for (let i = 0; i < rollingColorList.length; i++) {
              let colorData = rollingColorList[i];
              rollNumColorArr.push(colorData.color);
              rollNumColor[colorData.num] = colorData.color;
            }
            that.$store.commit("setRollNumColor", rollNumColor);
            that.$store.commit("setRollNumColorArr", rollNumColorArr);
          } else {
            // that.$store.commit("setRollNumColor", that.rollNumColor);
            // that.$store.commit("setRollNumColorArr", that.rollNumColorArr);
          }

          if (
            compactionColorList != null &&
            compactionColorList != undefined &&
            compactionColorList.length > 0
          ) {
            for (let j = 0; j < compactionColorList.length; j++) {
              let compactionColor = compactionColorList[j];
              icvColorArr.push(compactionColor.color);
              icvColor[compactionColor.maxCompaction] = compactionColor.color;
            }

            that.$store.commit("setIcvColor", icvColor);
            that.$store.commit("setIcvColorArr", icvColorArr);
          } else {
            // that.$store.commit("setIcvColor", that.icvColor);
            // that.$store.commit("setIcvColorArr", that.icvColorArr);
          }

          if (
            paverTemperatureColorList != null &&
            paverTemperatureColorList != undefined &&
            paverTemperatureColorList.length > 0
          ) {
            for (let j = 0; j < paverTemperatureColorList.length; j++) {
              let compactionColor = paverTemperatureColorList[j];
              pavColorArr.push(compactionColor.color);
              pavColor[compactionColor.maxTemperature] = compactionColor.color;
            }

            that.$store.commit("setPavColor", pavColor);
            that.$store.commit("setPavColorArr", pavColorArr);
          } else {
            // that.$store.commit("setIcvColor", that.icvColor);
            // that.$store.commit("setIcvColorArr", that.icvColorArr);
          }

          if (
            temperatureColorList != null &&
            temperatureColorList != undefined &&
            temperatureColorList.length > 0
          ) {
            for (let j = 0; j < temperatureColorList.length; j++) {
              let compactionColor = temperatureColorList[j];
              rollColorArr.push(compactionColor.color);
              rollColor[compactionColor.maxTemperature] = compactionColor.color;
            }

            that.$store.commit("setRollColor", rollColor);
            that.$store.commit("setRollColorArr", rollColorArr);
            console.log(Object.keys(rollColor))
          } else {
            // that.$store.commit("setIcvColor", that.icvColor);
            // that.$store.commit("setIcvColorArr", that.icvColorArr);
          }
        });
      }
    },
  },
};
</script> 

<style>
* {
  box-sizing: border-box;
}

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  /* text-align: center; */
  color: #2c3e50;
  /* margin-top: 60px; */
  box-sizing: border-box;
  height: 100%;
}

html {
  padding: 0;
  margin: 0;
  height: 100%;
  width: 100%;
}

body {
  padding: 0;
  margin: 0;
  height: 100%;
  width: 100%;
  background-color: #f2f2f5;
  box-sizing: border-box;
}

::-webkit-scrollbar {
  width: 6px;
  height: 6px;
  background: transparent;
}

::-webkit-scrollbar-thumb {
  background: transparent;
  border-radius: 4px;
}

:hover::-webkit-scrollbar-thumb {
  background: hsla(0, 0%, 53%, 0.4);
}

:hover::-webkit-scrollbar-track {
  background: hsla(0, 0%, 53%, 0.1);
}

.el-button {
  height: 36px !important;
  padding: 10px !important;
  border-radius: 1px !important;
  font-size: 14px !important;
}

.el-button--danger {
  background-color: #e96b5a !important;
}

.el-button--warning {
  background: rgba(254, 235, 232, 1) !important;
  border: 1px solid rgba(233, 107, 90, 1) !important;
  border-radius: 1px !important;
  color: #e4523f !important;
}

.searchContent .el-input {
  width: 180px !important;
  height: 36px !important;
  margin-left: 23px;
  margin-right: 23px;
  font-size: 14px !important;
}

.searchContent .el-input__inner {
  width: 180px !important;
  height: 36px !important;
  border-radius: 1px !important;
}

.searchInputText {
  height: 36px;
  line-height: 36px;
  display: inline-block;
  margin-left: 35px;
  color: #222222;
  font-size: 14px;
}

/* .el-table__header tr th {
    background-color: #ffe8e8 !important;
    color: #E96B5A !important;
    padding: 7px 0 !important;
} */
.el-table__header tr th {
  background-color: #f2f2f5 !important;
  color: #555555 !important;
  font-size: 14px;
}

el-table__row .cell {
  color: #555555 !important;
}

.pageBlock {
  float: right;
  /* position: fixed; */
  /* width: 600px !important; */
  height: 35px !important;
  line-height: 35px !important;
  margin-right: 25px;
  margin-top: 16px;
  /* bottom: 0;
  left: 0; */
}

.el-pagination__total {
  height: 35px !important;
  line-height: 35px !important;
}

.pageBlock .el-pagination__sizes {
  height: 35px !important;
  width: 95px !important;
}

.pageBlock .el-pagination__sizes .el-select {
  height: 35px !important;
  width: 95px !important;
}

.pageBlock .el-pagination__sizes .el-select .el-input {
  height: 35px !important;
  width: 95px !important;
}

.pageBlock .el-pagination__sizes .el-select .el-input .el-input__inner {
  height: 35px !important;
  width: 95px !important;
}

.pageBlock .el-pagination__sizes .el-select .el-input .el-input__suffix {
  left: 60px;
}

.pageBlock .btn-prev {
  width: 35px !important;
  height: 35px !important;
  background: rgba(255, 255, 255, 1) !important;
  border: 1px solid rgba(225, 225, 225, 1) !important;
  border-radius: 2px !important;
}

.pageBlock .btn-next {
  width: 35px !important;
  height: 35px !important;
  background: rgba(255, 255, 255, 1) !important;
  border: 1px solid rgba(225, 225, 225, 1) !important;
  border-radius: 2px !important;
}

.pageBlock .el-pager {
  height: 35px !important;
}

.pageBlock .el-pager .number {
  width: 35px !important;
  height: 35px !important;
  line-height: 35px !important;
}

.pageBlock .el-pager .active {
  background-color: #e96b5a !important;
}

.pageBlock .el-pagination__jump {
  height: 35px !important;
}

.pageBlock .el-pagination__jump .el-input {
  height: 35px !important;
  width: 35px !important;
  margin: 0 10px !important;
}

.pageBlock .el-pagination__jump .el-input .el-input__inner {
  height: 35px !important;
  width: 35px !important;
}

.is-indeterminate .el-checkbox__inner {
  background-color: #e96b5a !important;
  border-color: #e96b5a !important;
}

.is-checked .el-checkbox__inner {
  background-color: #e96b5a !important;
  border-color: #e96b5a !important;
}

/* .el-dialog__footer .el-button--primary{
  background-color: #E96B5A !important;
  border-color: #E96B5A !important;
  padding: 10px 20px !important;
  font-size: 14px !important;
  border-radius: 4px !important;
} */

.el-dialog {
  width: 920px !important;
}

/* .el-dialog .el-form{
   display: flex;
 } */
.el-form-item {
  float: left;
}

.el-dialog .el-form-item__label {
  width: 150px !important;
}

.el-dialog .el-form-item__content {
  margin-left: 150px !important;
  /* width: 220px !important; */
}

.el-dialog .longType {
  width: 660px !important;
}

.el-dialog .shotType {
  width: 255px !important;
}

.el-dialog .el-input {
  /* width: 220px !important; */
}

.el-step__main .el-step__title {
  font-size: 14px !important;
  line-height: 70px !important;
}

.el-step__main .is-wait {
  color: #555555 !important;
}

.is-success {
  color: #e96b5a !important;
  border-color: #e96b5a !important;
}

.inputType1 {
  height: 45px;
  width: 680px;
  border-radius: 2px;
}

.inputType1 input {
  width: 680px !important;
  height: 45px !important;
}

.inputType2 {
  height: 45px;
  width: 269px;
  border-radius: 2px;
}

.inputType2 input {
  width: 269px !important;
  height: 45px !important;
}

.projectInfo .el-input__inner {
  border: 0 !important;
}

.parameterContent .currency_same .el-input__inner {
  height: 57px !important;
}

.wordStatus_1 {
  display: inline-block;
  color: #999999;
  font-size: 14px;
  padding: 4px 8px;
  background: rgba(242, 242, 245, 1);
}

.wordStatus_2 {
  display: inline-block;
  color: #10bd62;
  font-size: 14px;
  padding: 4px 8px;
  background: rgba(221, 240, 229, 1);
}

.wordStatus_3 {
  display: inline-block;
  color: #2273f8;
  font-size: 14px;
  padding: 4px 6px;
  background: rgba(225, 235, 250, 1);
}

.wordStatus_4 {
  display: inline-block;
  color: #e96b5a;
  font-size: 14px;
  padding: 4px 8px;
  background: #feebe8;
}

.anchorBL {
  display: none;
}</style>
